module.exports = __webpack_public_path__ + "img/服装-裙子.1c2acc16.jpg";